<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-08 10:08:54
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-04-25 12:23:29
 -->
<template>
  <div :id="chartId" :style="{width:chartWidth,height:chartHeight}"></div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: {}
    },
    chartId: {
      type: String
    },
    chartWidth: {
      type: String,
      default: "100%"
    },
    chartHeight: {
      type: String,
      default: "8rem"
    }
  },
  data() {
    return {
      echarts: require("echarts"),
      chartFun: undefined,
      varOptions: undefined,
      defaultOption: {
        tooltip: {
          trigger: "axis"
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: function() {
              return "";
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#eee"],
              width: 1,
              type: "solid"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            //y轴刻度线
            show: false
          }
        }
      },
      seriesOption: {}
    };
  },
  watch: {
    options: {
      handler: function(val, oldVal) {
        this.initChart(val);
      },
      deep: true
    }
  },
  mounted() {
    this.initChart(this.options);
    window.addEventListener("resize", () => {
      this.resizeHandler();
    });
  },
  methods: {
    initChart(val) {
      this.chartFun = this.echarts.init(document.getElementById(this.chartId));
      this.seriesOption = {
        areaStyle: {
          normal: {
            color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#6c7ef3"
              },
              {
                offset: 1,
                color: "#fff"
              }
            ])
          }
        },
        type: "line",
        symbolSize: 0,
        itemStyle: {
          normal: {
            color: "#6c7ef3", //折点颜色
            lineStyle: {
              color: "#6c7ef3" //折线颜色
            }
          }
        }
      };
      this.varOptions = Object.assign({}, val, this.defaultOption);
      Object.assign(this.varOptions.series[0], this.seriesOption);
      this.chartFun.setOption(this.varOptions, true);
    },
    resizeHandler() {
      this.chartFun.resize();
    }
  }
};
</script>